import React from "react";
import AntdTransfer from 'antd/lib/transfer';
import {withError} from '@fishx/tracker';

const Transfer = (props) => <AntdTransfer {...props} />
Transfer.displayName = 'Transfer';
export default withError(Transfer);



// WEBPACK FOOTER //
// ./src/components/transfer/index.tsx